export const authMessages = {
  backgroundImageAlt: "Children's books",
  login: {
    title: 'Welcome back',
    subtitle: 'Login to your wfsc account',
    emailLabel: 'Email',
    emailPlaceholder: 'm@example.com',
    passwordLabel: 'Password',
    forgotPassword: 'Forgot your password?',
    submitButton: 'Login',
    loadingButton: 'Logging in...',
    noAccount: "Don't have an account? ",
    signUpLink: 'Sign up',
  },
  signup: {
    title: 'Create an account',
    subtitle: 'Enter your details to get started.',
    emailLabel: 'Email',
    emailPlaceholder: 'm@example.com',
    passwordLabel: 'Password',
    confirmPasswordLabel: 'Confirm Password',
    submitButton: 'Create account',
    loadingButton: 'Creating account...',
    hasAccount: 'Already have an account? ',
    signInLink: 'Sign in',
    passwordMismatch: 'Passwords do not match',
    emailConfirmation:
      'Sign up successful! Please check your email to confirm your account.',
  },
  forgotPassword: {
    title: 'Reset Password',
    subtitle:
      "Enter your email address below and we'll send you a link to reset your password.",
    emailLabel: 'Email',
    emailPlaceholder: 'm@example.com',
    submitButton: 'Send reset link',
    loadingButton: 'Sending...',
    rememberedPassword: 'Remembered your password? ',
    loginLink: 'Login',
    resetEmailSent: 'Password reset email sent! Check your inbox.',
  },
} as const;
